export class ValidityResultModel {
    emailNeedsToBeEntered: boolean;
    fatcaMustBeDisplayed: boolean;
    generalConditionsNeedToBeValidated: boolean;
    isFirstFatca: boolean;
    passwordNeedsToBeChanged: boolean;
    role: string;
    riskProfileMustBeSet: boolean;
}
